/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_WorkbenchInputs */

const en_titles_workbench = /** @type {(inputs: Titles_WorkbenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workbench`)
};

/**
* | output |
* | --- |
* | "Workbench" |
*
* @param {Titles_WorkbenchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const titles_workbench = /** @type {((inputs?: Titles_WorkbenchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_WorkbenchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_workbench(inputs)
});